export const accent = '#2d4ef5';
